// extracted by mini-css-extract-plugin
module.exports = {"input":"inputText_input__1HKnT","label":"inputText_label__2LGBd"};